import { callbacks, setCallback } from './callbacks';
import { app } from './appEnvironment';
import utils from '../scripts/utils';

const askLocation = (successCallback, errorCallback) => {
    setCallback("afterLocationSuccess", successCallback);
    setCallback("afterLocationError", errorCallback);
    app.callFunction("askLocation");
}

const onLocationSuccess = (data) => {
    data = utils.fromStringToJson(data);
    callbacks.afterLocationSuccess(data);
}

const onLocationError = (data) => {
    data = utils.fromStringToJson(data);
    callbacks.afterLocationError(data);
}

const initLocation = () => {
    window.onLocationSuccess = onLocationSuccess;
    window.onLocationError = onLocationError;
}

export { askLocation, initLocation };